import gql from "graphql-tag";
import { ArticleCategory } from "../../api/schema";

export interface ArticleCategoryViewResponse {
  articleCategory: ArticleCategory;
}

export interface ArticleCategoryListResponse {
  articleCategories: Array<ArticleCategory>;
}

export interface CreateArticleCategoryResponse {
  createArticleCategory: { id: number };
}

export interface UpdateArticleCategoryResponse {
  updateArticleCategory: { id: number };
}

export interface DeleteArticleCategoryResponse {
  deleteArticleCategory: boolean;
}

export interface CreateKeyFieldResponse {
  createKeyField: { id: number };
}

export interface UpdateKeyFieldResponse {
  updateKeyField: { id: number };
}

export interface DeleteKeyFieldResponse {
  deleteKeyField: boolean;
}

export const ArticleCategoryListQuery = gql`
  query articleCategories {
    articleCategories {
      id
      name
      fields {
        updated_at
        created_at
        required
        values
        unit
        type
        id
      }
      created_at
      updated_at
    }
  }
`;

export const ArticleCategoryViewQuery = gql`
  query articleCategory($id: ID!) {
    articleCategory(id: $id) {
      id
      name
      fields {
        id
        name
        type
        unit
        values
        required
        created_at
        updated_at
      }
      updated_at
      created_at
    }
  }
`;

export const CreateArticleCategoryMutation = gql`
  mutation createArticleCategory($values: CreateArticleCategoryInput!) {
    createArticleCategory(values: $values) {
      id
    }
  }
`;

export const UpdateArticleCategoryMutation = gql`
  mutation updateArticleCategory($values: UpdateArticleCategoryInput!) {
    updateArticleCategory(values: $values) {
      id
    }
  }
`;

export const DeleteArticleCategoryMutation = gql`
  mutation deleteArticleCategory($id: ID!) {
    deleteArticleCategory(id: $id)
  }
`;

export const CreateKeyFieldMutation = gql`
  mutation createKeyField($values: CreateKeyFieldInput!) {
    createKeyField(values: $values) {
      id
    }
  }
`;

export const UpdateKeyFieldMutation = gql`
  mutation updateKeyField($values: UpdateKeyFieldInput!) {
    updateKeyField(values: $values) {
      id
    }
  }
`;

export const DeleteKeyFieldMutation = gql`
  mutation deleteKeyField($id: ID!) {
    deleteKeyField(id: $id)
  }
`;
